'use client';
import styled from 'styled-components';

export const StyledScreeningStepContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;

export const StyledStepContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  border-radius: 32px;
  ${({ theme }) => theme.fontFamily.base}
  background-color: ${({ theme }) => theme.colors.background.lightest};
  padding: ${({ theme }) => theme.spacing(7)};
  margin-bottom: ${({ theme }) => theme.spacing(6)};

  @media ${({ theme }) => theme.tabletL} {
    padding: ${({ theme }) => theme.spacing(11)};
    max-width: 960px;
  }
`;
